import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { ActivityService } from '../../../../modules/user/activity/activity.service';
import { ActivityModel } from '../../../../modules/user/activity/activity.model';
import { BankAccountService } from '../../../../modules/finanzas/bancos/bankaccount.service';
import { BankAccountModel } from '../../../../modules/finanzas/bancos/bankaccount.model';
import { PreinvoiceService } from '../../../../modules/invoice/preinvoice/preinvoice.service';
import { MasterService } from '../../../master/services/master.service';
import { MasterModel } from '../../../master/models/master.model';
import { ActualSelected } from '../../../../shared/utils';

export interface CreditProjectLookups {
  enabled: boolean;
  projects: MasterModel[];
  expenseProjectTypes: MasterModel[];
}

export const CREDIT_INTEREST_TAX_NAME = 'IRPF 19% Cesión a terceros de capitales propios';

@Injectable({ providedIn: 'root' })
export class CreditLookupsService {

  constructor(
    private activityService: ActivityService,
    private bankAccountService: BankAccountService,
    private preinvoiceService: PreinvoiceService,
    private masterService: MasterService,
  ) { }

  activities(): Promise<ActivityModel[]> {
    return this.activityService.getActiveList()
      .then(list => (Array.isArray(list) ? list : []))
      .catch(() => []);
  }

  bankAccounts(): Promise<BankAccountModel[]> {
    return this.bankAccountService.getLookupList()
      .catch(() => []);
  }

  interestTaxes(): Promise<any[]> {
    return this.preinvoiceService.accountsAndTaxesData()
      .then(data => ((data && data.taxes) || []).filter((x: any) => x.name === CREDIT_INTEREST_TAX_NAME))
      .catch(() => []);
  }

  projects(): Promise<CreditProjectLookups> {
    return this.activityService.loadData(ActualSelected.activitySelected)
      .then(res => !!(res && res.isProject))
      .catch(() => false)
      .then(enabled => {
        if (!enabled) return { enabled, projects: [], expenseProjectTypes: [] };
        return Promise.all([
          firstValueFrom(this.masterService.getProjects()).catch(() => [] as MasterModel[]),
          firstValueFrom(this.masterService.getExpenseProjectTypes()).catch(() => [] as MasterModel[]),
        ]).then(([projectList, typeList]) => ({
          enabled,
          projects: projectList || [],
          expenseProjectTypes: typeList || [],
        }));
      });
  }
}
